import * as React from 'react';

export default class ArchiveIcon extends React.Component {
  render() {
    return React.createElement('svg', {
      className: this.props.className,
      viewBox: '0 0 24 24',
      dangerouslySetInnerHTML: {
        __html:
          '<path d="M23.1,10.3c0-0.3-0.1-0.7-0.2-1.1L20,3c-0.6-1.8-1.6-3-2.9-3H6C4.7,0,3.8,1.3,3.2,3.2L1,9.2C0.9,9.6,0.8,10,0.9,10.3h0v0.9v9.7C0.9,22.6,2.3,24,4,24h16c1.7,0,3.1-1.4,3.1-3.1v-9.7L23.1,10.3L23.1,10.3z M2.6,9.8l2.2-6.1c0.4-1.3,0.9-2,1.2-2h11.1c0.3,0,0.9,0.8,1.3,2l2.9,6.3c0.1,0.3,0.1,0.3-0.2,0.3H2.9C2.6,10.3,2.5,10.2,2.6,9.8z M20,22.3H4c-0.8,0-1.4-0.6-1.4-1.4V12h0.4h18.2h0.3v8.9C21.4,21.6,20.8,22.3,20,22.3z M5.1,8.6c0-0.5,0.4-0.9,0.9-0.9h11.1c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9H6C5.5,9.4,5.1,9,5.1,8.6z M14,14.6h-4c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3h4c1.3,0,2.3-1,2.3-2.3C16.3,15.6,15.3,14.6,14,14.6z M14,17.4h-4c-0.3,0-0.6-0.2-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h4c0.3,0,0.6,0.2,0.6,0.6C14.6,17.2,14.3,17.4,14,17.4z M6,6c0-0.5,0.4-0.9,0.9-0.9h9.4c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9H6.9C6.4,6.9,6,6.5,6,6z M6.9,3.4c0-0.5,0.4-0.9,0.9-0.9h7.7c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9H7.7C7.2,4.3,6.9,3.9,6.9,3.4z"/>',
      },
    });
  }
}
